"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadBase = _interopRequireDefault(require("../upload-base"));

var _constants = require("../constants");

var _uploadError = _interopRequireDefault(require("../upload-error"));

var _errorCodes = _interopRequireDefault(require("../error-codes"));

var _stream = require("stream");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents a request that can be sent via HTTP using the HttpClient. Options on
 * the request can be set via chaining its "with" methods together.
 */
var HttpRequest = /*#__PURE__*/function (_UploadBase) {
  _inherits(HttpRequest, _UploadBase);

  var _super = _createSuper(HttpRequest);

  /**
   * Constructs a new request using the given values. Default method
   * is GET.
   * @param {object} options 
   * @param {string} url URL to which the request will be sent.
   */
  function HttpRequest(options, url) {
    var _this;

    _classCallCheck(this, HttpRequest);

    _this = _super.call(this, options);
    _this.requestOptions = {
      url: url,
      method: HttpRequest.Method.GET,
      timeout: _constants.DefaultValues.REQUEST_TIMEOUT
    };
    _this.headers = {};
    _this.cancelId = '';
    _this.totalTransferred = 0;
    return _this;
  }
  /**
   * Sets various configurations of the request based on the values provided
   * in the given upload options.
   * @param {DirectBinaryUploadOptions} uploadOptions Options to use when
   *  configuring request.
   * @returns The current request instance, so that methods can be chained.
   */


  _createClass(HttpRequest, [{
    key: "withUploadOptions",
    value: function withUploadOptions(uploadOptions) {
      return this.withHeaders(uploadOptions.getHeaders()).withTimeout(uploadOptions.getHttpRequestTimeout());
    }
    /**
     * Sets the amount of time, in milliseconds, that the request will wait before
     * timing out.
     * @param {number} timeoutMilliseconds Time span in milliseconds.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withTimeout",
    value: function withTimeout(timeoutMilliseconds) {
      this.requestOptions.timeout = timeoutMilliseconds;
      return this;
    }
    /**
     * Sets the HTTP method that the request will use.
     *
     * @param {Method} method The HTTP method of the request. Should be one of
     *  the class's static Method values.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withMethod",
    value: function withMethod(method) {
      this.requestOptions.method = method;
      return this;
    }
    /**
     * Sets the content type of the request.
     *
     * @param {string} contentType HTTP content type.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withContentType",
    value: function withContentType(contentType) {
      this.headers['Content-Type'] = contentType;
      return this;
    }
    /**
     * Sets the headers that the request will use. Will be merged with any
     * other headers that have already been set on the request.
     *
     * @param {object} headers Simple object whose keys should be header names,
     *  and whose values should be header values.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withHeaders",
    value: function withHeaders(headers) {
      this.headers = _objectSpread({}, this.headers, {}, headers);
      return this;
    }
    /**
     * Sets raw data that will be sent in the body of the request. The type of the data
     * can vary, and accepted types are shown on the rawData parameter.
     *
     * This option is only applicable for PUT and POST.
     *
     * If data is provided, then the request will emit an event named "progress" whenever
     * there has been a meaninful amount of data uploaded. The event's data will be the
     * amount of data, in bytes, that has transferred since the last time the event was
     * sent.
     *
     * @param {string|object|ArrayBuffer|ArrayBufferView|URLSearchParams|FormData|File|Blob|Stream|Buffer} rawData
     *  Data to send in the request's body.
     * @param {number} [dataSize] The total size, in bytes, of the provided data. If not provided then
     *  the request will attempt to derive the size from the data, but note that this may fail for
     *  some data types.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withData",
    value: function withData(rawData) {
      var _this2 = this;

      var dataSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.requestOptions.data = rawData;

      if (rawData.on) {
        // in Axios, the "onUploadProgress" option only works in a Browser. In
        // Node.js, use the Stream's events to report progress
        rawData.on('data', function (chunk) {
          _this2.sendProgressEvent(chunk.length, true);
        });
      } else {
        // only available in a Browser.
        this.requestOptions.onUploadProgress = function (progress) {
          var loaded = progress.loaded;

          if (loaded) {
            _this2.sendProgressEvent(loaded, false);
          }
        };
      }

      if (rawData && rawData instanceof _stream.Readable) {
        if (dataSize) {
          this.logDebug('Adding content-length header for size', dataSize);
          this.withHeaders({
            'Content-Length': dataSize
          });
        } else {
          throw new _uploadError.default('Request data objects without a length must specify a size', _errorCodes.default.INVALID_OPTIONS);
        }
      }

      return this;
    }
    /**
     * Sets the type of response expected from the server. Should be one of the
     * class's static ResponseType values.
     * @param {string} responseType Type of response to expect. Default: JSON.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withResponseType",
    value: function withResponseType(responseType) {
      this.requestOptions.responseType = responseType;
      return this;
    }
    /**
     * Specifies an identifier that can be used in the HttpClient's cancel() method to cancel
     * this request. Note that the ID doesn't need to be unique to the request.
     *
     * @param {string} cancelId Used to cancel the request, if needed.
     * @returns The current request instance, so that methods can be chained.
     */

  }, {
    key: "withCancelId",
    value: function withCancelId(cancelId) {
      this.cancelId = cancelId;
      return this;
    }
    /**
     * Retrieves the ID that was set using the request's withCancelId() method.
     *
     * @returns The request's cancel ID.
     */

  }, {
    key: "getCancelId",
    value: function getCancelId() {
      return this.cancelId;
    }
    /**
     * Sends a 'progress' event for the request, which will include the
     * incremental amount of data transferred.
     * @param {number} transferred Amount of bytes transferred. This could
     *  be the total amount, or an incremental amount since the last event,
     *  depending on the isIncremental parameter.
     * @param {boolean} isIncremental If true, the transferred value is an
     *  incremental amount since the last event; otherwise it's the total
     *  amount transferred.
     */

  }, {
    key: "sendProgressEvent",
    value: function sendProgressEvent(transferred, isIncremental) {
      var incLoaded = transferred;

      if (isIncremental) {
        this.totalTransferred += transferred;
      } else {
        incLoaded = transferred - this.totalTransferred;
        this.totalTransferred = transferred;
      }

      this.sendEvent('progress', {
        transferred: incLoaded
      });
    }
    /**
     * Converts the request to a simple object.
     * @returns {object} Object containing the request's information.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return _objectSpread({
        headers: this.headers
      }, this.requestOptions);
    }
  }]);

  return HttpRequest;
}(_uploadBase.default);
/**
 * Available HTTP method that can be used for the request.
 */


HttpRequest.Method = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  HEAD: 'head',
  DELETE: 'delete'
};
/**
 * Valid values that can be used for the withResponseType() method.
 */

HttpRequest.ResponseType = {
  ARRAY_BUFFER: 'arraybuffer',
  DOCUMENT: 'document',
  JSON: 'json',
  TEXT: 'text',
  STREAM: 'stream',
  BLOB: 'blob'
};
var _default = HttpRequest;
exports.default = _default;